export enum PmmlSourceType {
    //default null
    NULL_VALUE="",
    //original values 
    MINING = "MINING",
    OUTPUT = "OUTPUT"
}